import { memo } from 'react';
import { connect } from 'react-redux';

import { DisappearingFlashMessage } from 'components/FlashMessage';
import { removeFlashMessage as removeFlashMessageRaw } from 'modules/main/store/ducks/flashMessages';

type Props = {
  flashMessages: Array<FlashMessageType>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeFlashMessage: (...args: Array<any>) => any;
};
const FlashMessageContainer = memo<Props>(
  ({ flashMessages, removeFlashMessage }: Props) => (
    <div id="flash-message-container">
      {flashMessages.map((flashMessage) => (
        <DisappearingFlashMessage
          key={flashMessage.id}
          flashMessage={flashMessage}
          removeMessage={() => removeFlashMessage(flashMessage.id)}
        />
      ))}
    </div>
  )
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = ({ flashMessages }: any) => ({
  flashMessages,
});

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, {
  removeFlashMessage: removeFlashMessageRaw,
})(FlashMessageContainer);
